import React from "react";
import { Link } from "react-router-dom";
import Header from "../Header/Header";
import Footer from "../../Components/Footer/Footer";
const TermsAndConditions = () => {
	return (
		<>
			<Header />
			<div className="min-h-screen bg-gray-50 px-4 py-10 sm:px-6 lg:px-16">
				{/* Container */}
				<div className="mx-auto max-w-5xl bg-white rounded-2xl shadow-md p-6 sm:p-10">

					{/* Title */}
					<h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">
						Terms and Conditions
					</h1>

					{/* Breadcrumb */}
					<p className="text-sm text-gray-500 mb-8">
						<Link to="/" className="hover:text-blue-600 transition-colors">
							Home
						</Link>
						<span className="mx-1">/</span>
						<span className="text-gray-700">Terms and Conditions</span>
					</p>

					{/* Content */}
					<div className="space-y-6 text-gray-700 text-sm sm:text-base leading-relaxed">

						<p>
							This document is an electronic record in terms of the Information
							Technology Act, 2000 and rules made thereunder. This electronic
							record is generated by a computer system and does not require any
							physical or digital signatures.
						</p>

						<p>
							This document is published in accordance with Rule 3 (1) of the
							Information Technology (Intermediaries Guidelines) Rules, 2011 for
							access or usage of the website{" "}
							<span className="font-semibold">https://zakkuu.com/</span> including
							its mobile site and application.
						</p>

						<p>
							The Platform is owned by{" "}
							<span className="font-semibold">
								DIGITAL NIGHT OWL PRIVATE LIMITED
							</span>
							, incorporated under the Companies Act, 1956, having its registered
							office at LG-32, D-233, Triangles Business Park, Noida, Gautam Buddha
							Nagar, India.
						</p>

						<p>
							Your use of the Platform and its services is governed by these Terms
							of Use. By accessing or using the Platform, you agree to be bound by
							these terms and applicable policies.
						</p>

						<p>
							Any additional or conflicting terms proposed by you are expressly
							rejected by the Platform Owner.
						</p>

						<p>
							These Terms of Use may be modified at any time. You are responsible
							for reviewing them periodically to stay informed of updates.
						</p>

						<p>
							For the purpose of these Terms, “you”, “your”, or “user” refers to
							any person who accesses or uses the Platform.
						</p>

						<p className="font-semibold text-gray-900">
							ACCESSING OR USING THE PLATFORM INDICATES YOUR ACCEPTANCE OF THESE
							TERMS OF USE.
						</p>

						{/* Terms List */}
						<ul className="list-disc pl-6 space-y-3">
							<li>
								You agree to provide accurate and complete information during
								registration and are responsible for activities through your
								account.
							</li>
							<li>
								We do not guarantee the accuracy, completeness, or suitability of
								information provided on the Platform.
							</li>
							<li>
								Your use of the Platform and Services is at your own risk.
							</li>
							<li>
								All content on the Platform is proprietary and protected by
								intellectual property laws.
							</li>
							<li>
								Unauthorized use may result in legal action.
							</li>
							<li>
								You agree to pay charges associated with availing Services.
							</li>
							<li>
								You shall not use the Platform for any unlawful purpose.
							</li>
							<li>
								Third-party links are provided for convenience and governed by
								their own policies.
							</li>
							<li>
								Transactions on the Platform constitute a legally binding
								contract.
							</li>
							<li>
								You agree to indemnify the Platform Owner against claims arising
								from your breach of these Terms.
							</li>
							<li>
								Performance delays due to force majeure events shall not result
								in liability.
							</li>
							<li>
								These Terms are governed by the laws of India.
							</li>
							<li>
								All disputes shall be subject to the exclusive jurisdiction of
								courts in Gautam Buddha Nagar, Uttar Pradesh.
							</li>
						</ul>

						<p>
							All communications regarding these Terms should be sent using the
							contact information provided on the Platform.
						</p>

					</div>
				</div>
			</div>
			<Footer />
		</>
	);
};

export default TermsAndConditions;
